import React from 'react';
import { MaskedInputLayoutProps } from '../types';
import { ErrorsWrapper } from 'ui-builder';
import { PhoneInput } from '../PhoneInput';

export default function MaskedInputLayoutWeb(props: MaskedInputLayoutProps) {
  return (
    <ErrorsWrapper errors={props.errors} name={props.name}>
      <PhoneInput
        value={props.value || undefined}
        onChange={props.onChangeCallback}
      />
    </ErrorsWrapper>
  );
}
